import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VLogoService } from 'src/app/models/entities/v-logo-service';
import { LogoService } from 'src/app/services/logo.service';

@Component({
  selector: 'app-logo-service',
  templateUrl: './logo-service.component.html',
  styleUrls: ['./logo-service.component.css']
})
export class LogoServiceComponent implements OnInit {

  logoServices$: Observable<VLogoService[]>;
  @ViewChild('dt', { static: false }) dt: any;
  constructor(private logoService: LogoService) { }

  ngOnInit(): void {
    this.logoServices$ = this.logoService.getServices().pipe(map(result => result.data));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

}
